import request from '@/utils/request'

export function getGridList(data) {
  return request({
    url: 'api/v1/tetris-grid/list',
    method: 'post',
    data: data
  })
}

export function updateGrid(data) {
  return request({
    url: 'api/v1/tetris-grid/update',
    method: 'post',
    data: data
  })
}

export function delGrid(data) {
  return request({
    url: 'api/v1/tetris-grid/delete',
    method: 'delete',
    data: data
  })
}

export function exportGrid() {
  return request({
    url: 'api/v1/tetris-grid/export',
    method: 'get'
  })
}

export function importGrid(data) {
  return request({
    url: 'api/v1/tetris-grid/import',
    method: 'post',
    data: data
  })
}

export function getGridIDNameMap(data) {
  return request({
    url: 'api/v1/tetris-grid/id-name-map',
    method: 'post',
    data: data
  })
}
